import type { BaseRoleEntity } from '@/features/baseRole/domain/entities/BaseRoleEntity'
import type { RoleEntity } from '@/features/role/domain/entities/RoleEntity'

export class UserRoleEntity {
  userId?: string
  baseRoles?: Array<BaseRoleEntity> | null
  roles?: Array<RoleEntity> | null
}
